<template>
  <v-sheet v-resize="onResize" class="product__swiper" elevation="0" rounded>
    <div class="swiper__header wd-py-3 wd-flex wd-justify-between" :class="headerClass">
      <h3 class="wd-mb-0" :class="titleClass">{{ title }}</h3>
      <div v-if="!isMobile" class="swiper-btn-group d-flex">
        <v-btn class="swiper-button swiper-prev mr-3 px-3 py-1" height="32" variant="text" @click="pathToCategoryPage">
          {{ $t('show_all') }}
        </v-btn>

        <v-btn
          class="swiper-button swiper-prev mr-3 pa-0"
          :class="{ disabled: disabledPrevBtn }"
          min-width="32"
          height="32"
          variant="text"
          aria-label="Prev Button"
          @click="prevSwiper"
        >
          <FunnowSvgIcon max-width="24" :image-path="'chevron-left.svg'" />
        </v-btn>

        <v-btn
          class="swiper-button swiper-next pa-0"
          :class="{ disabled: disabledNextBtn }"
          min-width="32"
          height="32"
          variant="text"
          aria-label="Next Button"
          @click="nextSwiper"
        >
          <FunnowSvgIcon max-width="24" :image-path="'chevron-right.svg'" />
        </v-btn>
      </div>
      <div v-if="isMobile && canShowingAllButtonShowOnMobile">
        <v-btn class="swiper-button swiper-prev mr-3 px-3 py-1" height="32" variant="text" @click="pathToCategoryPage">
          {{ $t('show_all') }}
        </v-btn>
      </div>
    </div>

    <div class="default-swiper__container mt-2">
      <swiper ref="productsSwiper" class="swiper" v-bind="swiperOption" @swiper="initSwiper" @slide-change-transition-end="onSlideChangeEnd">
        <swiper-slide v-for="idx in swiperItemsCount" :key="idx">
          <template v-if="items[idx - 1]">
            <BranchCard v-if="isBranchCardMode" :branch="items[idx - 1]" />
            <product-card v-else :product="items[idx - 1]" />
          </template>
          <v-skeleton-loader v-else type="card" />
        </swiper-slide>
      </swiper>
    </div>
  </v-sheet>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue'

import ProductCard from '@/components/card/product.vue'
import BranchCard from '@/components/card/BranchCard.vue'
import FunnowSvgIcon from '@/components/icons/funnow-svg-icon'
import { CategoryType } from '@/view-models/category'
import { provideGtmSource } from '@/composition/useGtmSource'

export default defineComponent({
  name: 'ProductSwiperIndex',
  components: {
    Swiper,
    SwiperSlide,
    ProductCard,
    BranchCard,
    FunnowSvgIcon,
  },
  props: {
    isMobile: { type: Boolean, default: false },
    canShowingAllButtonShowOnMobile: { type: Boolean, default: false },
    headerClass: { type: String, default: 'wd-items-center' },
    title: { type: String, default: '' },
    titleClass: { type: String, default: 'header__title' },
    regionId: { type: [String, Number], default: '' },
    categoryId: { type: [String, Number], default: '' },
    categoryType: { type: Number, default: 0 },
    isBranchCardMode: { type: Boolean, default: true },
    items: { type: Array, default: () => [] },
    source: { type: String, default: null },
  },
  setup(props) {
    provideGtmSource(props.source)

    const { swiper, disabledPrevBtn, disabledNextBtn, initSwiper, prevSwiper, nextSwiper, switchSwiperBtnStatus, onResize, onSlideChangeEnd } =
      useSwiperFactory()
    const localePath = useLocalePath()

    return {
      swiper,
      disabledPrevBtn,
      disabledNextBtn,
      initSwiper,
      prevSwiper,
      nextSwiper,
      switchSwiperBtnStatus,
      onResize,
      onSlideChangeEnd,
      localePath,
    }
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 'auto',
        slidesOffsetAfter: 20,
        spaceBetween: 8,
        breakpoints: {
          420: {
            spaceBetween: 16,
          },
        },
      },
    }
  },
  computed: {
    /** @return {number} */
    swiperItemsCount() {
      return this.items.length || 10
    },
  },
  watch: {
    items() {
      this.switchSwiperBtnStatus()
    },
  },
  methods: {
    pathToCategoryPage() {
      if (this.regionId && this.categoryId) {
        const name = this.categoryType === CategoryType.Category ? 'regions-rid-categories-id' : 'regions-rid-themes-id'
        this.$router.push(this.localePath({ name, params: { rid: this.regionId, id: this.categoryId } }))
      } else {
        console.error('pathToCategoryPage: error', 'Do not get regionId or categoryId')
      }
    },
  },
})
</script>

<style scoped lang="scss">
.product__swiper {
  .swiper__header {
    .header__title {
      font-weight: 500;
      font-size: 24px;
      line-height: 32px;

      @include xxs {
        font-size: 20px;
      }
    }
    .medium__header__title {
      font-weight: 500;
      font-size: 20px;
      line-height: 28px;
    }
  }

  .swiper-slide {
    width: 290px;
  }

  .swiper-btn-group {
    .swiper-button {
      &.disabled {
        color: $gray60;
        pointer-events: none;
      }
    }
  }
}
</style>
